import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.sidebar');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-sidebar',
template: templateSource || '',
    styles: [``],
})
export class LayoutSidebarComponent implements OnInit {
    public session: any = {};

    public pages: any[] = [
        { link: '/dashboard', shortTitle: '캘린더' },
        { link: '/missions', shortTitle: '순찰 실행' },
        { link: '/ai-review', shortTitle: 'AI 검토' },
        { link: '/reports', shortTitle: '보고서 작성' }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init(this);
        this.session = this.service.auth?.session || {};
    }

    public isActive(link: string) {
        const pathname = location.pathname;
        if (link === '/dashboard' && pathname === '/') return true;
        return pathname.indexOf(link) === 0;
    }

    public topbarNavClass(item: any) {
        return `ops-topnav-link is-${this.stepState(item)}${this.isActive(item.link) ? ' is-active' : ''}`;
    }

    public settingsNavClass() {
        return `ops-settings-link${this.isActive('/villages') ? ' is-active' : ''}`;
    }

    public stepState(item: any) {
        const itemIndex = this.pages.findIndex((page: any) => page.link === item.link);
        const currentIndex = this.currentStepIndex();
        if (itemIndex < currentIndex) return 'complete';
        if (itemIndex === currentIndex) return 'current';
        return 'pending';
    }

    public currentStepIndex() {
        const index = this.pages.findIndex((item: any) => this.isActive(item.link));
        return index;
    }

    public timestampLabel() {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hour = String(now.getHours()).padStart(2, '0');
        const minute = String(now.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day} ${hour}:${minute}`;
    }

    public userInitial() {
        const name = this.session?.name || '운영';
        return name.charAt(0);
    }

    public userDepartment() {
        return this.session?.department || this.session?.team || this.session?.role || '운영 담당';
    }

}

export default LayoutSidebarComponent;